import { SelectorComponentInterface } from "@mecatran/selector-component-interface";
import './datetime.css';  // TMP


class TimeOptions{
    constructor(){
        var _steps = 300; // 5minutes 

        Object.defineProperty(this,'steps',{
            set : function(s){ _steps = s },
            get : function(){ return _steps }
        })
    }
}


export class DateTime extends SelectorComponentInterface{
    constructor(type, id ){
        super();
        var typeSet = new Set(['time','date']);
        var _type = typeSet.has(type) ? type : 'time';
        var _DOMNode,
            _uniqueId = Math.round(Math.random() * 100000),
            _id = id || _uniqueId,
            _selectEventHandlers = []
        ; 

        Object.defineProperty(this,'id',{
            get : function(){ return _id },
        });
        
        Object.defineProperty(this,'type',{
            get : function(){ return _type }
        });
        
        Object.defineProperty(this,'label',{
            get : function(){ return _label }
        });


        Object.defineProperty(this,'DOMNode',{
            get : function(){ return _DOMNode },
            set : function(d){ _DOMNode = d }
        });

        Object.defineProperty(this,'selectEventHandlers',{
            get : function(){ return _selectEventHandlers }
        });

        // init 
        this.init();

    }

    // ====
    // init
    // ----
    init(){
        var dateTime = this.createDateTime(this.getId());
        this.setDOMNode(dateTime);
        this.setDatetimeListeners();
    }

    // ========================
    // interface implementation
    // -------------------------
    getDOMNode(){
        return this.DOMNode;
    }



    // =======
    // getters
    // -------
    getType(){ return this.type }

    getId(){ return this.id }

    getUniqueId(){ return this.uniqueId }

    getInput(){
        var dateTime = this.getDOMNode();
        return dateTime.querySelector('input');
    }

    getSelectEventHandlers(){ return this.selectEventHandlers }

    getCurrentTimeStr(format){
        var timeStr = new Date().toTimeString().split(' ')[0]; // HH:MM:SS
        switch(format){
            case 'HH:MM':
                timeStr = timeStr.substring(0,5)
            break;
        }
        return timeStr;
    }

    getCurrentDateStr(format){
        var dateStr = new Date().toISOString().split('T')[0];  // yyyy-mm-dd
        switch(format){
            case 'yyyy-mm-dd':
                dateStr = dateStr;
                break;
        }
        return dateStr;
    }

    getValue(){
        var input = this.getInput();
        return input.value;
    }
    

    // =========
    // modifiers
    // ---------
    setDOMNode(d){ this.DOMNode = d }

    setTime(timeStr){
        var input = this.getInput();
        if (timeStr){  // IMPROVE. Check the type and format. 
            input.value = timeStr;
        } else input.value = this.getCurrentTimeStr('HH:MM');
    }

    setDate(dateStr){
        var input = this.getInput();
        if (dateStr){ // IMPROVE. Check the type and format (yyyy-MM-dd)
            input.value = dateStr; 
        } else input.value = this.getCurrentDateStr('yyyy-MM-dd')
    }

    /**
     * 
     * @param value Optional. If not set, will default to currentTime. If set. ex: '2020-11-19' or '12:35'
     */
    setDefaultValue(value){ 
        var value; 
        switch(this.getType()){
            case 'time':
                value = value || this.getCurrentTimeStr('HH:MM');
                this.setTime(value);
                break;
            case 'date':
                value = value ||this.getCurrentDateStr('yyyy-MM-dd');
                this.setDate(value);
                break;
        }
    }

    createDateTime(id){
        var dateTime = document.createElement('div');
        dateTime.setAttribute('class', this.getType());
        dateTime.setAttribute('id',id);
        var input = document.createElement('input');
        input.setAttribute('type',this.getType());
        dateTime.appendChild(input);
        return dateTime;
    }

    // =========
    // listeners
    // ---------
    setDatetimeListeners(){
        var datetime = this.getDOMNode();
        datetime.addEventListener('click',this.eventsRouter.bind(this));
        datetime.addEventListener('change', this.eventsRouter.bind(this));
        datetime.addEventListener('selectEvent',this.eventsRouter.bind(this));
    }

    // =============
    // events router
    // -------------

    eventsRouter(e){
        e.stopPropagation();
        switch(e.type){
            case 'click':
                this.onClick(e);
                break;
            case 'change': 
                this.onChange(e);
                break;
            case 'selectEvent':
                if (e.target ) this.onSelectEvent(e); // to complete 
                break;
        }
    }

    // ========
    // handlers
    // --------

    onChange(e){
        this.emitSelectEvent(this.getValue())
        console.log('onchange value:', this.getValue())
    }

    onClick(e){
        var str = 'click' + e.target;
        console.log(str)
    }

    onSelectEvent(e){
        var handlers = this.getSelectEventHandlers();
        var handler;
        var value = e.detail;
        handlers.forEach(handler => handler(value));
    }

    // =============
    // event Emitter
    // -------------
    // ======
    // events
    // ------
    emitSelectEvent(value){
        var event = new CustomEvent('selectEvent', { 'detail': value, bubbles: true });  // https://developer.mozilla.org/fr/docs/Web/API/Event/Event
        this.getDOMNode().dispatchEvent(event);
    } 

    // ======
    // public
    // ------
    getCurrentSelection(){
        var input = this.getInput();
        return input.value;
    } 

    addSelectEventHandler(handler){
        var handlers = this.getSelectEventHandlers();
        handlers.push(handler);
    } 

}
